import axios from "axios";
import { StatisticsURL } from "../Services";
import { authenticatedHeader } from "../DefaultConfig";
import { HideAwaiting, ShowAwaiting } from "../../util/Awaiting";
import { authenticatedGetAPI, authenticatedPostAPI } from "../GenericAPICall";

type Keywords = {
  keywords: string[];
};

export async function followKeywords(props: Keywords) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/keyword/following/save-batch",
    props,
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function getFollowKeywords() {
  ShowAwaiting();
  var res = await axios.get(
    StatisticsURL + "api/keyword/following/all",
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function getKeywordSource(keyword: string) {
  // refreshToken();
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/content/view/related-to",
    keyword,
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function getKeywordTopicDistribution(
  keyword: string,
  day: number
) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/keyword/view/topics-distribution",
    { keyword: keyword, x: day },
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function createKeywordCluster(
  name: string,
  relatedKeywords: string[]
) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/keyword/following/cluster/save",
    { name: name, relatedKeywords: relatedKeywords },
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function updateKeywordCluster(
  id: number,
  name: string,
  relatedKeywords: string[]
) {
  var res = await authenticatedPostAPI(
    StatisticsURL + "api/keyword/following/cluster/update",
    { id: id, name: name, relatedKeywords: relatedKeywords }
  );
  return res.data;
}

export async function deleteKeywordCluster(id: number) {
  ShowAwaiting();
  var res = await axios.delete(
    StatisticsURL + "api/keyword/following/cluster/" + id.toString(),
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function findAllClusters() {
  var res = await authenticatedGetAPI(
    StatisticsURL + "api/keyword/following/cluster/all"
  );
  return res;
}

export async function getKeywordPortrait(keyword: string, days: number) {
  var res = await authenticatedPostAPI(
    StatisticsURL + "api/keyword/view/portrait",
    { x: days, keyword: keyword }
  );
  return res;
}

export async function getKeywordPairStory(
  keyword: string,
  adjacentKeyword: string,
  days: number
) {
  var res = await authenticatedPostAPI(
    StatisticsURL + "api/keyword/view/pair",
    {
      keyword,
      adjacentKeyword,
      days,
    }
  );
  return res;
}

export async function requestClusterReport(
  clusterID: number,
  startTime: string,
  endedTime: string,
  additionalQuestions: string[]
) {
  var res = await authenticatedPostAPI(
    StatisticsURL + "api/keyword/following/cluster/report",
    {
      clusterID,
      startTime,
      endedTime,
      additionalQuestions,
    }
  );
  return res;
}

export async function requestKeywordReport(
  keyword: string,
  startTime: string,
  endedTime: string,
  additionalQuestions: string[]
) {
  var res = await authenticatedPostAPI(
    StatisticsURL + "api/keyword/following/keyword/report",
    {
      keyword,
      startTime,
      endedTime,
      additionalQuestions,
    }
  );
  return res;
}

export async function clusterReportDetail(id: number) {
  var res = await authenticatedPostAPI(
    StatisticsURL + "api/keyword/following/cluster/report/detail",
    {
      id,
    }
  );
  return res;
}

export async function keywordReportDetail(id: number) {
  var res = await authenticatedPostAPI(
    StatisticsURL + "api/keyword/following/keyword/report/detail",
    {
      id,
    }
  );
  return res;
}

export async function recentKeywordCampaigns() {
  var res = await authenticatedGetAPI(
    StatisticsURL + "api/keyword/view/campaigns/recent"
  );
  return res;
}

export async function campaignsRelatedToFollowingKeywords() {
  var res = await authenticatedGetAPI(
    StatisticsURL + "api/keyword/view/campaigns/related"
  );
  return res;
}

export async function getFollowingCampaigns() {
  var res = await authenticatedGetAPI(
    StatisticsURL + "api/keyword/view/campaigns/following"
  );
  return res;
}

export async function getPopularCampaigns() {
  var res = await authenticatedGetAPI(
    StatisticsURL + "api/keyword/view/campaigns/popular"
  );
  return res;
}

export async function campaignDetail(id: number) {
  var res = await authenticatedPostAPI(
    StatisticsURL + "api/keyword/view/campaign/detail",
    {
      id,
    }
  );
  return res;
}

export async function followCampaign(id: number) {
  var res = await authenticatedPostAPI(
    StatisticsURL + "api/keyword/view/campaign/follow",
    {
      id,
    }
  );
  return res;
}

export async function unfollowCampaign(id: number) {
  var res = await authenticatedPostAPI(
    StatisticsURL + "api/keyword/view/campaign/unfollow",
    {
      id,
    }
  );
  return res;
}
